import { Component, OnInit, HostBinding } from '@angular/core';

import { LocalStorageService } from '../../core/upgraded-providers';
import {
    style,
    animate,
    transition,
    trigger,
    state
} from '@angular/animations';

const fadeTransition = trigger('fade', [
    state('fadeIn', style({ opacity: 1, visibility: 'visible' })),
    state('fadeOut', style({ opacity: 0, visibility: 'hidden' })),
    transition('* <=> *', [
        animate(250)
    ])
]);

const magicDelay = 1500;

@Component({
    selector: 'app-tutorial-alert',
    templateUrl: './tutorial-alert.component.pug',
    styleUrls: ['./tutorial-alert.component.less'],
    animations: [
        fadeTransition
    ]
})
export class TutorialAlertComponent implements OnInit {

    public isHidden = true;
    public fade = 'fadeOut';

    @HostBinding('class.rocket--show') rocketShow: boolean = false;
    @HostBinding('class.rocket--arrive') rocketArrive: boolean = false;
    @HostBinding('class.rocket--fly') rocketFly: boolean = false;

    constructor(
        private _localStorageService: LocalStorageService
    ) {

        if (_localStorageService.get('nw-menu.tutorial-alert')) {
            this.rocketArrive = true;

            setTimeout(() => {
                this.rocketArrive = false;
                this.rocketFly = true;
            }, magicDelay);

            return;
        }

        this.rocketArrive = true;
        setTimeout(() => {
            this.rocketShow = true;
            this.isHidden = null;
            this.fade = 'fadeIn';
        }, magicDelay);
    }

    ngOnInit() {
    }

    onHide() {
        this._localStorageService.put('nw-menu.tutorial-alert', true);
        this.fade = 'fadeOut';

        this.rocketArrive = false;
        this.rocketFly = true;
    }

    onShow() {
        this._localStorageService.put('nw-menu.tutorial-alert', false);
        this.isHidden = null;
        this.fade = 'fadeIn';

        this.rocketShow = true;
        this.rocketFly = false;
    }
}
